window.cpfValidation = (cpf) => {
  let soma;
  let resto;
  soma = 0;
  cpf = cpf.replace(/\D/g, '');
  if (cpf == "00000000000") return false;
  if (cpf == "11111111111") return false;
  if (cpf == "22222222222") return false;
  if (cpf == "33333333333") return false;
  if (cpf == "44444444444") return false;
  if (cpf == "55555555555") return false;
  if (cpf == "66666666666") return false;
  if (cpf == "77777777777") return false;
  if (cpf == "88888888888") return false;
  if (cpf == "99999999999") return false;

  for (i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if ((resto == 10) || (resto == 11)) resto = 0;
  if (resto != parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if ((resto == 10) || (resto == 11)) resto = 0;
  if (resto != parseInt(cpf.substring(10, 11))) return false;
  return true;
}

window.cnpjValidation = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj == '') return false;

  if (cnpj.length != 14)
    return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999")
    return false;

  // Valida DVs
  tamanho = cnpj.length - 2
  numeros = cnpj.substring(0, tamanho);
  digitos = cnpj.substring(tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;
}

window.emailValidation = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

$(document).ready(function () {
  $(document).on("input", ".numbers-dot-comma", function (ev) {
    const val = ev.target.value;
    const correctVal = val.replace(/[^\d,.]+/g, '');
    $(this).val(correctVal);
    $(this).change();
  });

  $(document).on("input", ".numbers-only", function (ev) {
    $(this).val($(this).val().replace(/\D/g, ''));
  });

  $(document).on("blur", ".cpf-validation", function (ev) {
    if ($(this).val() !== "" && !window.cpfValidation($(this).val())) {
      alert("CPF inválido");
      $(this).val("");
    }
  });

  $(document).on("blur", ".email-validation", function (ev) {
    if ($(this).val() !== "" && !window.emailValidation($(this).val())) {
      alert("Endereço de e-mail inválido");
      $(this).val("");
    }
  });
});

const loading = document.createElement("div");
loading.classList.add("page-overlay");
const spinner = document.createElement("div");
spinner.classList.add("spinner");
loading.appendChild(spinner);
const body = document.querySelector("body");

window.showPageLoading = () => {
  try {
    body.removeChild(loading);
  } catch (e) {}
  body.prepend(loading);
}

window.hidePageLoading = () => {
  try {
    body.removeChild(loading);
  } catch (e) {}
}

// Directive for numeric input
Vue.directive('numeric', {
  bind(el) {
    el.addEventListener('input', () => {
      let regex = /^[0-9]*$/
      if (!regex.test(el.value)) {
        el.value = el.value.replace(/\D/g, '');

        const event = new Event('input');
        el.dispatchEvent(event);
      }
    })
  }
});

window.clone = (data) => JSON.parse(JSON.stringify(data));

window.getScrollParent = (node) => {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return window.getScrollParent(node.parentNode);
  }
}

window.validateForm = (formEl) => {
  let hasError = false;
  let focusSeted = false;

  formEl
    .querySelectorAll(".form-group")
    .forEach(node => {
      node.classList.remove("error");
      let errorMsg = null;

      if (node.classList.contains("radio-group")) {
        const radioChecked = node.querySelector(".form-control:checked");
        if (!radioChecked && node.classList.contains("required")) {
          errorMsg = "Campo obrigatório";
        }
      }

      const formControl = node.querySelector(".form-control");

      if (formControl) {
        const dataValidations = formControl.getAttribute("data-validation");
        const val = formControl.value;

        if (node.classList.contains("required") && !val) {
          errorMsg = "Campo obrigatório";
        } else if (formControl.getAttribute("max") && parseInt(val) > parseInt(formControl.getAttribute("max"))) {
          errorMsg = `O valor deve ser no máximo ${formControl.getAttribute("max")}`;
        } else if (formControl.getAttribute("min") && parseInt(val) < parseInt(formControl.getAttribute("min"))) {
          errorMsg = `O valor deve ser no mínimo ${formControl.getAttribute("min")}`;
        } else if (node.classList.contains("required") && formControl.getAttribute("type") == "email" && !window.emailValidation(val)) {
          errorMsg = "Endereço de e-mail inválido";
        } else if (dataValidations && val != "") {
          const validations = dataValidations.split("|");
          for (let i = 0; i < validations.length; i++) {
            const validation = validations[i];

            if (validation == "cpf" && !window.cpfValidation(val)) {
              errorMsg = "CPF inválido.";
              break;
            } else if (validation == "cnpj" && !window.cnpjValidation(val)) {
              errorMsg = "CPF inválido.";
              break;
            }
          }
        }
      }

      if (errorMsg) {
        node.classList.add("error");
        hasError = true;

        let errorMsgEl = node.querySelector(".error-msg");

        if (!errorMsgEl) {
          errorMsgEl = document.createElement("span");
          errorMsgEl.classList.add("error-msg");
          node.append(errorMsgEl);
        }

        errorMsgEl.innerText = errorMsg;

        if (formControl && !focusSeted) {
          formControl.focus();
          focusSeted = true;
        }

        const formControlInputHandler = () => {
          node.classList.remove("error");
          formControl.removeEventListener("input", formControlInputHandler)
        }

        formControl && formControl.addEventListener("input", formControlInputHandler);
      }
    });

  // Check if required checkbox are checked
  formEl
    .querySelectorAll(".form-check.required")
    .forEach((node) => {
      const checkInput = node.querySelector(".form-check-input");
      if (!checkInput.checked) {
        node.classList.add("error");
        hasError = true;

        if (!focusSeted) {
          checkInput.focus();
          focusSeted = true;
        }
      } else {
        node.classList.remove("error");
      }
    });

  return !hasError;
};

window.loadAddressByCep = (cep, callback) => {
  cep = cep.replace(/\D/g, '');
  const url = `https://viacep.com.br/ws/${cep}/json`;

  axios
    .get(url)
    .then(response => response.data)
    .then(data => {
      if (data.erro) {
        throw "CEP Inválido";
      } else {
        callback(data);
      }
    })
    .catch(error => {
      const emptyData = {
        cep: '',
        logradouro: '',
        bairro: '',
        localidade: '',
        uf: '',
        error: true
      }
      callback(emptyData);
    });
}
